import { IHasServices } from './IHasServices';

export class Employee implements IHasServices {
    public id: string;
    public name: string;
    public department: string;
    public phoneNumber: string;

    public hasTicketApp: boolean;

    constructor(employeeId: string, name: string, department: string, phoneNumber: string, hasTicketApp: boolean) {
        this.id = employeeId;
        this.name = name;
        this.department = department;
        this.phoneNumber = phoneNumber;
        this.hasTicketApp = hasTicketApp;
    }
}
